import { render } from "./Consulting.vue?vue&type=template&id=452628ee&scoped=true"
import script from "./Consulting.vue?vue&type=script&lang=js"
export * from "./Consulting.vue?vue&type=script&lang=js"

import "@/assets/css/layout_request.css?vue&type=style&index=0&id=452628ee&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452628ee"]])

export default __exports__